import { NameDto } from '@/api/Common/Types/NameDto'

export enum SubscriptionDetailDetailsKey {
  name = 'subscription.name',
  type = 'subscription.group.type.name',
  level = 'detailType.shortName',
  mappingText = 'mappingText',
  amount = 'amount',
  currency = 'subscription.currency.id',
  enabled = 'subscription.enabled',
  order = 'subscription.order',
  product = 'subscription.tickmillProduct.name',
}

export enum EmailsFilterKey {
  name = 'Name',
  subject = 'Subject',
  fromType = 'FromType',
  group = 'Group',
  archive = 'Archive',
}

export interface ModelProperties {
  defaultValue: string
  type: string
  subProperties: {}
}

interface EmployeeModel {
  name: string
  position: string
}

interface PersonModel {
  genderId: number
  firstName: string
  lastName: string
  productIds?: number[]
}

export interface Email {
  id: number
  name: string
  subject: string
  model: string
  modelProperties: {
    [key: string]: ModelProperties
  }
  fromType: string
  archive: boolean
  group: null
  trigger: null
  createdDate: string
  updatedDate: string
}

export interface EmailPreview {
  body: string | null
  subject: string | null
}

export interface SendEmail extends EmailPreviewRequest {
  cc: string[]
}

export interface EmailPreviewModel {
  platform?: Record<string, unknown>
  products?: NameDto[]
  [key: string]: unknown
}

export interface EmailPreviewRequest {
  clientId?: string
  leadId?: string
  tickmillCompanyId?: number
  to?: string
  person?: PersonModel

  template: string
  url?: string
  employee: EmployeeModel
  language: string
  tickmillPublicDomain: string
  model?: EmailPreviewModel
}
